import { Component } from 'react';

export class DownloadSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16 15.3334C16 15.7014 15.7013 16.0001 15.3333 16.0001H0.666667C0.298667 16.0001 0 15.7014 0 15.3334C0 14.9654 0.298667 14.6667 0.666667 14.6667H15.3333C15.7013 14.6667 16 14.9654 16 15.3334Z"
                    fill="#0C2340"
                />
                <path
                    d="M3.3335 6L8.00016 12L12.6668 6H8.66683V0.666667C8.66683 0.298 8.36883 0 8.00016 0C7.6315 0 7.3335 0.298 7.3335 0.666667V6H3.3335Z"
                    fill="#0C2340"
                />
            </svg>
        );
    }
}
